import { __assign } from "tslib";
import { Drawer, styled } from '@mui/material';
export var StyledDialogPanel = styled(Drawer, {
    shouldForwardProp: function (prop) { return !['open'].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme, open = _a.open;
    return ({
        '> .MuiPaper-root': __assign({ position: "absolute", top: 0, right: 0, bottom: 0, width: theme.spacing(6), minWidth: theme.spacing(6), 
            // padding: 8,
            boxSizing: "border-box", overflowX: "hidden", transition: " 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms ", transitionProperty: "width, min-width, overflow", overflow: "hidden" }, (open && {
            width: 336,
            padding: "0",
            overflow: "overlay",
        })),
    });
});
//# sourceMappingURL=styled.js.map